export default {
  cats: 'Коти',
  dogs: 'Собаки',
  all_pets: 'Всі тварини',
  without_pets: 'Без тварин',
};
